import { GatewaysAuthPage } from "./gateways/GatewaysAuth";

// CentralGateway, ExternalGateway and Auth share one interactive page; the route selects the tab
export const CentralGatewayPage = GatewaysAuthPage;
